import React from 'react';
import { Divider, Grid, Typography } from '@mui/material';

/**
 * The title with the divider above every form
 * @param {string} title - The title of the form
 */
const FormTitle = ({ title }) => {
  return (
    <Grid
      container
      className="d-flex align-center justify-between"
      component="div"
    >
      <Grid item md={5} sm={6} lg={4}>
        <Typography component="h2" variant="h3" color="primary">
          {title}
        </Typography>
      </Grid>
      <Grid item md={7} sm={6} lg={8}>
        <Divider sx={{ backgroundColor: 'rgba(0,0,0,0.6)', height: '1px' }} />
      </Grid>
    </Grid>
  );
};

export default FormTitle;
